import React, { useEffect, useState, useRef } from "react";
import { useNavigate ,useLocation} from "react-router-dom";
import axios from "axios";
import FRONTEND_CONFIG from "./frontend_config";

export default function ExamPage() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [showPermissionPopup, setShowPermissionPopup] = useState(true);

  const [answers, setAnswers] = useState({});

// SAVE ANSWERS IN LOCAL STORAGE
useEffect(() => {
  localStorage.setItem("answers", JSON.stringify(answers));
}, [answers]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const videoChunks = useRef([]);

  const [timeLeft, setTimeLeft] = useState(30 * 60);

// ⏳ Calculate time left based on EXAM_END
useEffect(() => {
  const examEndTime = new Date(FRONTEND_CONFIG.EXAM_END).getTime();
  const now = Date.now();

  const remainingSeconds = Math.floor((examEndTime - now) / 1000);

  if (remainingSeconds <= 0) {
    alert("⛔ Exam time window is over.");
    navigate("/thank-you");
    return;
  }

  setTimeLeft(remainingSeconds);
}, []);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const location = useLocation();
  const dashboardData = location.state?.dashboardData;
  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  const [warningShown, setWarningShown] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const screenStreamRef = useRef(null);
const cameraStreamRef = useRef(null);
const recordingStartedRef = useRef(false); // ✅ LOCK TO PREVENT DOUBLE POPUP
const handleStartExam = async () => {
  const allowed = await startRecording();
  if (!allowed) return;  // ❌ Stay on popup

  // ✅ Start exam
  setShowPermissionPopup(false);
};


const startRecording = async () => {

  // Prevent double popup
  if (recordingStartedRef.current) {
    return false;
  }
  recordingStartedRef.current = true;

  try {
    // 🖥️ START SCREEN
    const screenStream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
      audio: true,
    }).catch(() => null);   // ⬅️ detect cancel

    if (!screenStream) {
      alert("⚠️ You must allow screen sharing to start the exam.");
      recordingStartedRef.current = false;
      return false;  // ⬅️ stop exam start
    }

    screenStreamRef.current = screenStream;

    // 🎥 START CAMERA
    const cameraStream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    }).catch(() => null);   // ⬅️ detect cancel

    if (!cameraStream) {
      alert("⚠️ You must allow camera & microphone to start the exam.");
      recordingStartedRef.current = false;
      return false;  // ⬅️ stop exam start
    }

    cameraStreamRef.current = cameraStream;

    const screenVideo = document.createElement("video");
    screenVideo.srcObject = screenStream;
    screenVideo.muted = true;
    await screenVideo.play();

    const cameraVideo = document.createElement("video");
    cameraVideo.srcObject = cameraStream;
    cameraVideo.muted = true;
    await cameraVideo.play();

    // 🎨 MIX WITH CANVAS
    const canvas = document.createElement("canvas");
    canvas.width = 1280;
    canvas.height = 720;
    const ctx = canvas.getContext("2d");

    const drawFrame = () => {
      ctx.drawImage(screenVideo, 0, 0, canvas.width, canvas.height);
      ctx.drawImage(cameraVideo, 1000, 20, 260, 190);
      requestAnimationFrame(drawFrame);
    };

    drawFrame();

    // 🎥 RECORD CANVAS STREAM
    const mixedStream = canvas.captureStream(30);

    // 🎤 ADD MIC AUDIO
    const audioTrack = cameraStream.getAudioTracks()[0];
    if (audioTrack) mixedStream.addTrack(audioTrack);

    const recorder = new MediaRecorder(mixedStream);
    setMediaRecorder(recorder);

    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) videoChunks.current.push(e.data);
    };

    recorder.start();
    console.log("🎥 Screen + Camera Recording Started");

    return true;  // ⬅️ success

  } catch (err) {
    console.error("Recording error:", err);
    recordingStartedRef.current = false;
    return false;  // ⬅️ stop exam
  }
};


  useEffect(() => {
    console.log("🧭 Dashboard Data from state:", dashboardData);
    console.log("🗄️ Dashboard Data from localStorage:", JSON.parse(localStorage.getItem("dashboardData")));
  }, []);

  const fetchQuestions = async () => {
    const storedData = JSON.parse(localStorage.getItem("dashboardData"));

    if (!storedData || !storedData.assignedQuestionSet) {
      alert("⚠️ No question set assigned. Please contact admin.");
      navigate("/");
      return;
    }

    const apiUrl = `${FRONTEND_CONFIG.API_URL}/api/questionset/${storedData.assignedQuestionSet}/questions`;

    try {
      const res = await axios.get(apiUrl);
      if (res.data.questions && res.data.questions.length > 0) {
        setQuestions(res.data.questions);
      } else {
        alert("⚠️ No questions found.");
      }
    } catch (err) {
      alert("❌ Error fetching questions!");
    }
  };

  useEffect(() => {
    const checkSubmission = async () => {
      const storedData = JSON.parse(localStorage.getItem("dashboardData"));
      if (!storedData) return;

      try {
        const res = await axios.get(
          `${FRONTEND_CONFIG.API_URL}/api/responses/check/${storedData._id}/${storedData.assignedQuestionSet}`
        );

        if (res.data.submitted) {
          alert("You have already submitted.");
          navigate("/thank-you");
          return;
        }

        fetchQuestions();
      } catch {}
    };

    checkSubmission();
  }, []);

  useEffect(() => {
    const handleTabChange = () => {
      if (document.visibilityState === "hidden") {
        setTabSwitchCount((prev) => prev + 1);
      }
    };

    document.addEventListener("visibilitychange", handleTabChange);
    return () => document.removeEventListener("visibilitychange", handleTabChange);
  }, []);

  useEffect(() => {
    if (tabSwitchCount === 1 && !warningShown) {
    alert("⚠️ Please do not switch tabs! If this happens again, your exam will be auto-submitted.");
      setWarningShown(true);
    }

    if (tabSwitchCount >= 2) {
    alert("⛔ You switched tabs again. Your exam will be auto-submitted.");
    handleSubmit();  // AUTO SUBMIT
    }
  }, [tabSwitchCount]);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", blockBack);
    return () => window.removeEventListener("popstate", blockBack);
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) {
      handleSubmit();
      return;
    }
    const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };
const handleBeforeUnload = () => {
  const db = localStorage.getItem("dashboardData");
  const ans = localStorage.getItem("answers");
  if (!db || !ans) return;

  const dashboardData = JSON.parse(db);
  const answers = JSON.parse(ans);

  const formatted = Object.entries(answers).map(([qid, val]) => ({
    questionId: qid,
    selectedOption: val,
    answerText: val,
    timeTaken: 0,
  }));

  const payload = {
    applicantId: dashboardData._id,
    questionSetId: dashboardData.assignedQuestionSet,
    responses: formatted,
  };

  // ✅ Send via fetch with keepalive
  fetch(`${FRONTEND_CONFIG.API_URL}/api/responses/auto`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    keepalive: true, // allows sending while tab closes
  });
};

useEffect(() => {
  const onClose = (e) => {
    handleBeforeUnload();
    e.preventDefault();
    e.returnValue = "";
  };

  window.addEventListener("beforeunload", onClose);

  return () => window.removeEventListener("beforeunload", onClose);
}, []);

  const handleAnswerChange = (qid, value) => {
    setAnswers((prev) => ({ ...prev, [qid]: value }));
  };

  const goToQuestion = (index) => setCurrentIndex(index);
  const goNext = () => setCurrentIndex((p) => Math.min(p + 1, questions.length - 1));
  const goPrev = () => setCurrentIndex((p) => Math.max(p - 1, 0));

  const openSubmitPopup = () => setShowConfirmPopup(true);
  const handleSubmit = async () => {
    const dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
    if (!dashboardData) return;

   if (mediaRecorder) {
  mediaRecorder.stop();
  console.log("🛑 Recording stopped");
}

// ✅ STOP SCREEN SHARING
if (screenStreamRef.current) {
  screenStreamRef.current.getTracks().forEach(track => track.stop());
  console.log("🖥️ Screen stopped");
}

// ✅ STOP CAMERA
if (cameraStreamRef.current) {
  cameraStreamRef.current.getTracks().forEach(track => track.stop());
  console.log("📷 Camera stopped");
}

    await new Promise((res) => setTimeout(res, 500)); // Wait for chunks

    // 🎥 Prepare video file
    const videoBlob = new Blob(videoChunks.current, { type: "video/webm" });
    const videoFile = new File([videoBlob], "exam_recording.webm", { type: "video/webm" });
// 🎥 UPLOAD TO BACKEND
const formData = new FormData();

// 👈 IMPORTANT: applicantId must come first
formData.append("applicantId", dashboardData._id);
formData.append("video", videoFile);

try {
  await axios.post(
    `${FRONTEND_CONFIG.API_URL}/api/video/upload-video`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  console.log("🎥 Video Uploaded");
} catch (err) {
  console.error("❌ Video upload failed:", err);
}

    const formattedResponses = Object.entries(answers).map(([qid, val]) => ({
      questionId: qid,
      selectedOption: typeof val === "string" ? val : null,
      answerText: typeof val === "string" ? val : null,
      timeTaken: 0,
    }));

    const payload = {
      applicantId: dashboardData._id,
      questionSetId: dashboardData.assignedQuestionSet,
      responses: formattedResponses,
    };

    try {
      await axios.post(`${FRONTEND_CONFIG.API_URL}/api/responses`, payload);

      setShowConfirmPopup(false);
      setShowSuccessPopup(true);
      setTimeout(() => navigate("/thank-you"), 2000);

    } catch (err) {
      alert("Failed to submit exam!");
    }
    recordingStartedRef.current = false; // ✅ Reset screen-record lock

  };

  const currentQuestion = questions[currentIndex];
  // ⭐ ADD THIS BEFORE THE MAIN RETURN
if (showPermissionPopup) {
  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }}>
      <div style={{
        width: "380px",
        background: "white",
        padding: "25px",
        borderRadius: "12px",
        textAlign: "center"
      }}>
        <h2>Permission Required</h2>
        <p style={{ marginTop: "10px", color: "#444" }}>
          To start the exam, please allow:
          <br/>📌 Screen Recording
          <br/>📌 Webcam & Microphone
        </p>

        <button
          style={{
            marginTop: "20px",
            background: "#2563eb",
            color: "white",
            padding: "12px 20px",
            borderRadius: "8px",
            border: "none",
            fontSize: "16px",
            cursor: "pointer"
          }}
          onClick={handleStartExam}
        >
          Allow & Start Exam
        </button>
      </div>
    </div>
  );
}

  return (
  <div style={{ padding: "20px", minHeight: "100vh", background: "#f9fafb" }}>

    {/* HEADER */}
    <div style={{ textAlign: "center", marginBottom: "20px" }}>
      <h1>🧠 Online Examination</h1>
      <h3 style={{ color: timeLeft <= 60 ? "red" : "#333" }}>
        Time Remaining: {formatTime(timeLeft)}
      </h3>
    </div>

    {/* TWO COLUMN LAYOUT */}
    <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
      
      {/* LEFT SIDE – QUESTION BOX */}
      <div style={{ flex: 3 }}>
        {currentQuestion ? (
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            <p style={{ fontSize: "18px" }}>
              <strong>Q{currentIndex + 1}:</strong> {currentQuestion.questionText}
            </p>

            {/* OPTIONS */}
            {currentQuestion.options && currentQuestion.options.length > 0 ? (
              currentQuestion.options.map((opt, idx) => (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <label>
                    <input
                      type="radio"
                      name={currentQuestion._id}
                      value={`Option ${String.fromCharCode(65 + idx)}`}
                      checked={
                        answers[currentQuestion._id] ===
                        `Option ${String.fromCharCode(65 + idx)}`
                      }
                      onChange={(e) =>
                        handleAnswerChange(currentQuestion._id, e.target.value)
                      }
                    />{" "}
                    {opt.optionText}
                  </label>
                </div>
              ))
            ) : (
              <textarea
                value={answers[currentQuestion._id] || ""}
                onChange={(e) =>
                  handleAnswerChange(currentQuestion._id, e.target.value)
                }
                placeholder="Write your answer..."
                style={{
                  width: "100%",
                  height: "80px",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />
            )}

            {/* PREV / NEXT BUTTONS */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <button
                onClick={goPrev}
                disabled={currentIndex === 0}
                style={{
                  background: "#6b7280",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  border: "none",
                  cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                }}
              >
                Previous
              </button>

              {currentIndex === questions.length - 1 ? (
                <button
                  onClick={openSubmitPopup}
                  style={{
                    background: "#2563eb",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Submit
                </button>
              ) : (
                <button
                  onClick={goNext}
                  style={{
                    background: "#2563eb",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Next
                </button>
              )}
            </div>
          </div>
        ) : (
          <p style={{ textAlign: "center", marginTop: "40px" }}>
            Loading your questions...
          </p>
        )}
      </div>

      {/* RIGHT SIDE – QUESTION PALETTE */}
      <div
        style={{
          flex: 1,
          border: "1px solid #ddd",
          padding: "15px",
          borderRadius: "10px",
          background: "#f8f8f8",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "10px" }}>
          Question Palette
        </h3>

        {/* GRID OF BUTTONS */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "8px",
          }}
        >
          {questions.map((q, i) => {
            const answered = answers[q._id];
            return (
              <button
                key={q._id}
                onClick={() => goToQuestion(i)}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor: answered ? "#22c55e" : "#ef4444",
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer",
                  boxShadow: currentIndex === i ? "0 0 4px 2px #2563eb" : "none",
                }}
              >
                {i + 1}
              </button>
            );
          })}
        </div>
      </div>
    </div>

    {/* POPUPS (UNCHANGED) */}
    {showConfirmPopup && (
      <div style={popupOverlay}>
        <div style={popupBox}>
          <h2>Submit Exam?</h2>
          <p>Are you sure you want to submit?</p>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <button style={cancelBtn} onClick={() => setShowConfirmPopup(false)}>
              Cancel
            </button>

            <button style={confirmBtn} onClick={handleSubmit}>
              Yes, Submit
            </button>
          </div>
        </div>
      </div>
    )}

    {showSuccessPopup && (
      <div style={popupOverlay}>
        <div style={successBox}>
          <h2>🎉 Exam Submitted!</h2>
        </div>
      </div>
    )}
  </div>
);
}
const popupOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const popupBox = {
  background: "#fff",
  width: "350px",
  padding: "25px",
  borderRadius: "12px",
  textAlign: "center",
  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
};

const successBox = {
  background: "#4ade80",
  color: "white",
  width: "350px",
  padding: "30px",
  borderRadius: "12px",
  textAlign: "center",
  fontSize: "20px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
};

const confirmBtn = {
  background: "#2563eb",
  color: "white",
  padding: "10px 18px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
};

const cancelBtn = {
  background: "#6b7280",
  color: "white",
  padding: "10px 18px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
};
